// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./peges/Home";
import AboutTheRace from "./peges/AboutTheRace";
import Results from "./peges/Results";
import Registration from "./peges/Registration";

import AdminLogin from "./peges/AdminLogin";
import AdminDashboard from "./peges/AdminDashboard";
import { getToken } from "./api";

function ProtectedRoute({ children }) {
  const token = getToken();
  return token ? children : <Navigate to="/admin-login" replace />;
}

export default function App() {
  return (
    <div>
      <Routes>
        {/* public */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutTheRace />} />
        <Route path="/results" element={<Results />} />
        <Route path="/registration" element={<Registration />} />

        {/* admin */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
